import { doc, fromCollectionRef } from 'rxfire/firestore';
import { useObservable } from '..';
export function useFirestoreDoc(ref, options) {
    return useObservable(doc(ref), ref.path, options ? options.startWithValue : undefined);
}
export function useFirestoreCollection(ref, options) {
    return useObservable(fromCollectionRef(ref), ref.path, options ? options.startWithValue : undefined);
}
